<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-row>
                <div class="link-name" v-text="config['link_name']"></div>
                <el-button size="mini" @click="openDialog"
                           v-text="config['link_name'] ? '更换表单' : '请选择表单'"></el-button>
            </el-row>
        </el-form-item>
        <el-dialog title="请选择表单" :visible.sync="dialog.visible" @close='closeDialog'>
            <normal-list :url="tableList.url" @close='closeDialog' :searchLabel="tableList.searchLabel"
                         :resultArrayName="tableList.resultArrayName" :titleName="tableList.titleName"
                         :count="tableList.count" @select="select" :idList="idList"></normal-list>
        </el-dialog>
    </div>
</template>

<style lang="scss">
</style>

<script>

  export default {
    name: 'tms-type-link',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
       source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 右侧组件数据初始化
      config() {
        if (this.source === 'tmsPageConfig') {
        return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
        return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        activeName: 'normal',
        tableList: {
          url: 'api/test/form/list',
          searchLabel: '',
          titleName: 'name',
          resultArrayName: 'form_list',
          count: 10
        },
        idList: []
      }
    },

    components: {
    },

    mounted() {

    },

    methods: {
      openDialog() {
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(row) {
        this.config['link_name'] = row.name;
        this.config['link_form_id'] = row._id;
        this.$set(this.config, this.field.key, row);
        this.dialog.visible = false;
      }
    }
  }

</script>
